import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * The field grows with what is typed, but only to a ceiling: an unbounded one
 * pushes whatever follows it — the buttons that submit or abandon the form —
 * off the bottom of a small screen.
 */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "field-sizing-content max-h-[min(24rem,45dvh)] min-h-20 w-full overflow-y-auto rounded-[5px] border border-rule bg-field px-2.5 py-2 font-mono text-[12px] leading-relaxed text-ink shadow-[inset_0_1px_1px_rgb(16_20_27/0.04)] transition-[border-color,box-shadow] outline-none",
        "placeholder:font-sans placeholder:text-ink-3 hover:border-rule-strong",
        "focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-brand/25",
        "disabled:cursor-not-allowed disabled:bg-raised disabled:text-ink-3",
        "aria-invalid:border-bad aria-invalid:ring-2 aria-invalid:ring-bad/20",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
